import {Component, OnInit} from '@angular/core';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
@Component({
  selector: 'app-table-column-date',
  templateUrl: './table-column-date.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TableColumnDateComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

  ngOnInit(): void {
  }

}
